/* import __COLOCATED_TEMPLATE__ from './request-access.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { type StandalonePlatform } from 'embercom/objects/standalone/constants';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';

interface Args {}

export default class StandaloneRequestAccess extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: any;

  get platformUrl() {
    if (this.finStandaloneService.zendeskConfig?.subdomain) {
      return `https://${this.finStandaloneService.zendeskConfig?.subdomain}.zendesk.com/agent/home`;
    } else if (this.finStandaloneService.salesforceConfig?.instanceUrl) {
      return `${this.finStandaloneService.salesforceConfig?.instanceUrl}/lightning/o/MessagingSession/list`;
    }

    return;
  }

  get platformName(): StandalonePlatform {
    if (this.appService.app.hasStandalonePlatform('salesforce')) {
      return 'salesforce';
    }

    return 'zendesk';
  }

  get imageUrl() {
    if (this.appService.app.hasStandalonePlatform('salesforce')) {
      return assetUrl('/assets/images/standalone/copilot-on-salesforce.png');
    }

    return assetUrl('/assets/images/standalone/copilot-on-zendesk.png');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::RequestAccess': typeof StandaloneRequestAccess;
  }
}
